import pptxgen from 'pptxgenjs'
import docmaLogo from "@/assets/docma-logo-white-red.svg"
import docmaBackground from "@/assets/docma-headslide-background.png"
import * as export_helper from './exportHelper'
import {GREEN_HEX_CODE, RED_HEX_CODE} from '@/constants/constants.js'

class PPTXBuilderPlanningPrediction {
    constructor(plan_name){
        this.pptx = new pptxgen();
        this.pptx_name = 'Docma Planning Prediction Export';
        this.plan_name = plan_name || "Temporary Plan" + new Date().toISOString().slice(0, 10) ;
        this.prediction_pages = {
            'Overview': {chart_elements:[], table_elements:[], stats_elements: []},
            //'Optimization_template': {chart_elements:[], table_elements:[], stats_elements: []},
        }
    }
    set_slide(){
        this.pptx.defineSlideMaster({
            title: "docma_slide",
            background: {color: "#FFFFFF"},
            objects: [
                {text: {text: "", options: {x: 0, y: 0, w: "100%", h: '15%', fill: '#000000'}}},
                {image: {x: 8.4, y: "3%", w: 1.4,h: 0.35, path: docmaLogo}},
                { text: { text: "CONFIDENTIAL", options: { x:'0%', y:'95%', w:'100%', h:'5%', align:'center', fill:'#000000', color:'#ffffff', fontSize: 12} } },
                { text: { text: new Date().toString().slice(4, 16), options: { x:'5%', y:'95%', w:'100%', h:'5%', align:'left', color:'#ffffff', fontSize: 8 } } }
            ],
            slideNumber: { x: "90%", y: "95%", color:'#ffffff' }
        })
        this.pptx.defineSlideMaster({
            title: "docma_subheader_slide",
            objects: [
                {image: {x: 0, y: 0, w:'100%' ,h:'100%', path: docmaBackground}},
                {image: {x: 8.4, y: "3%", w: 1.4,h: 0.35, path: docmaLogo}},
                {text: { text: "CONFIDENTIAL", options: { x:'0%', y:'95%', w:'100%', h:'5%', align:'center', fill:'#000000', color:'#ffffff', fontSize: 12} } }
            ]
        })
    }

    add_header_slide(){
        let slide = this.pptx.addSlide({masterName: "docma_subheader_slide"});
        slide.addText("Docma Prediction Export",{x: '5%',y: '3%', w: "50%", h: 3, align: 'left', fontFace: 'Poppins', fontWeight: 'Bold', fontSize: 30, color: '#ffffff'});
        slide.addText(this.plan_name,{x: '5%',y: '13%', w: "50%", h: 3, align: 'left', fontFace: 'Poppins', fontSize: 20, color: '#ffffff'});
    }

    add_element(element, page, type){
        if(page && type && element) {
            if(!this.prediction_pages[page]) {
                this.prediction_pages[page] = {chart_elements: [], table_elements: [], stats_elements: []};
            }
            if(type == 'chart') {
                this.prediction_pages[page]['chart_elements'].push(element);
            } else if(type == 'table') {
                this.prediction_pages[page]['table_elements'].push(element);
            } else if(type == 'stats') {
                this.prediction_pages[page]['stats_elements'].push(element);
            }
        }
    }

    build_overview_slide(){
        // to be implemented
        const tableComp = this.prediction_pages['Overview']['table_elements'][0];
        const chartComp = this.prediction_pages['Overview']['chart_elements'][0];

        const slide = this.pptx.addSlide({masterName: "docma_slide"});
        const table_header_name = export_helper.build_table_header_name(tableComp.table_headers)
        const table_header_value = export_helper.build_table_header_value(tableComp.table_headers)
        const table_body = export_helper.build_table_body(tableComp.table_data, table_header_value, true);

        slide.addText("Overview",
            {
                x:0, y:'0.12',w:'75%',h:'10%',
                align: 'left', fontFace: 'Poppins', fontSize: 25, color:'#ffffff'
            }
        );

        slide.addImage({data: chartComp.chart_image, x: 0.25, y: 1.5, h: 1.25, w: 9.5});
    
        slide.addTable([table_header_name],{x:0.05, y:3.0, w:9.9, h:0.2, fontFace: 'Poppins', fontSize: 5, fill:'black', color:'#ffffff', border:{pt: "1", color: '#000000'}});
        slide.addTable(table_body, {x:0.05, y:3.2 , w:9.9, autoPage:true, autoPageRepeatHeader:true, autoPageLineWeight:0.5, newSlideStartY: 1, fontFace: 'Poppins', fontSize: 5, border:{pt: "1", color: '#000000'}});

    }

    build_prediction_slides(){
        // to be implemented

        for (let page in this.prediction_pages) {
            if (page === 'Overview') continue; // Skip the overview page as it's handled separately
            const slide = this.pptx.addSlide({masterName: "docma_slide"});

            slide.addText(page,
                {
                    x:0, y:'0.12',w:'75%',h:'10%',
                    align: 'left', fontFace: 'Poppins', fontSize: 25, color:'#ffffff'
                }
            );

            console.log(page)
            console.log(this.prediction_pages[page])

            const tableComp = this.prediction_pages[page]['table_elements'][0];
            const chartComps = this.prediction_pages[page]['chart_elements'];
            const statsComps = this.prediction_pages[page]['stats_elements']

            const left_section_width = 6.5
            const stat_comp_width = left_section_width/3

            let idx = 0;
            statsComps.forEach(comp => {
                slide.addText(export_helper.format_spend(comp.value), {x:0.1 + idx * stat_comp_width, y:1.25 , w:1, h:0.3, align:'right', fontFace: 'Poppins', fontSize: 12, color:'#000000'});
                slide.addText(export_helper.format_percentage(comp.change), {x:1.0 + idx * stat_comp_width, y:1.25, w:1, h:0.3, align:'left', fontFace: 'Poppins', fontSize: 8, color: comp.change > 0 ? GREEN_HEX_CODE : RED_HEX_CODE });
                slide.addText(comp.stats_name, {x:0.8 + idx * stat_comp_width, y:1.45, w:1, h:0.3, align:'left', fontFace: 'Poppins', fontSize: 6, color:'#000000', fontWeight: 'Bold'});
                idx++;
            });

            if (tableComp) {
                const table_header_name = export_helper.build_table_header_name(tableComp.table_headers)
                const table_header_value = export_helper.build_table_header_value(tableComp.table_headers)
                const table_body = export_helper.build_table_body(tableComp.table_data, table_header_value, true);

                slide.addTable([table_header_name], {x:0.05, y:2.0, w:6.5, h:0.2, fontFace: 'Poppins', fontSize: 5, fill:'black', color:'#ffffff', border:{pt: "1", color: '#000000'}});
                slide.addTable(table_body, {x:0.05, y:2.2 , w:6.5, autoPage:true, autoPageRepeatHeader:true, autoPageLineWeight:0.5, newSlideStartY: 1, fontFace: 'Poppins', fontSize: 5, border:{pt: "1", color: '#000000'}});
            }
            
            if (chartComps && chartComps.length) {
                const chartLayouts = [
                    {fallbackTitle: 'Spend', titleY: 1.3, imageY: 1.57},
                    {fallbackTitle: 'Volume', titleY: 3.2, imageY: 3.47},
                ];

                chartComps.slice(0, 2).forEach((chartComp, chartIdx) => {
                    const layout = chartLayouts[chartIdx];
                    const chartTitle = chartComp.chart_name
                        ? chartComp.chart_name.replace(/^Prediction\s+/, '').replace(/\s+Chart$/, '')
                        : layout.fallbackTitle;

                    slide.addText(chartTitle, {x:7.35, y:layout.titleY, w:1.6, h:0.25, align:'left', fontFace: 'Poppins', fontSize: 10, color:'#000000', fontWeight: 'Bold'});
                    slide.addImage({data: chartComp.chart_image, x: 6.8, y: layout.imageY, h: 1.6, w: 3.0});
                });
            }
        }
    }

    build(){
        this.set_slide();
        this.add_header_slide();
        
        // Add overview slide sss
        this.build_overview_slide();

        // Add prediction slides
        this.build_prediction_slides();
    }

    save(){
        this.pptx.writeFile(this.pptx_name);
    }
}
export default PPTXBuilderPlanningPrediction
